import { useMemo } from 'react'
import { useConnections } from '@/features/integrations'
import { resolveConnectionRow } from '@/hooks/resolveConnectionRow'

/**
 * Live connections for Settings → Connections.
 *
 * Previously assembled from three sessionStorage keys seeded with demo rows,
 * so the list vanished on reload and never reflected a real account. `refetch`
 * is now a real refetch rather than a no-op.
 *
 * @returns {{ connections: object[], refetch: () => void, isLoading: boolean, error: unknown }}
 */
export default function useSettingsConnections() {
  const { data, refetch, isLoading, error } = useConnections()

  const connections = useMemo(
    () =>
      (data ?? []).map((connection) =>
        resolveConnectionRow({
          id: connection.id,
          toolkitSlug: connection.toolkit_slug ?? '',
          status: connection.status,
          isDisabled: connection.is_disabled,
          approvedCount: connection.approved_count,
          requiresApproval: connection.requires_approval,
          permissionsStatus: connection.permissions_status,
          displayLabel: connection.display_label,
        }),
      ),
    [data],
  )

  return { connections, refetch, isLoading, error }
}
